/**
 * 加单模块中文文案。键与 ko-KR 一一对应。
 * 状态/动作码直接以枚举值为键（reorder.status.REQUESTED 等），画面按值取。
 */
export default {
  reorder: {
    exportTooLarge: '导出记录过多，请缩小品牌范围后重试；未生成不完整文件',
    deliveryRequired: '请明确填写交期后再进行生产确认',
    workFactoryRequired: '请明确选择作业工厂后再进行生产确认',
    source: {
      disabled: '销售库存资料接入尚未启用', adminOnly: '仅管理员可以导入销售库存资料',
      invalidDate: '资料期间不能晚于来源日期', foreignBrand: '资料包含其他品牌的款号',
      invalidBatch: '批次重复或不属于本次款号', incomplete: '来源总行数与有效及排除行数不一致',
      changedRun: '该来源版本内容已变化，请核对后使用新的发布版本',
      stale: '不能用较旧资料覆盖当前资料', foreignSnapshot: '该日期已有其他来源的资料，请先核对',
      quantityOverflow: '资料数量超出支持范围', invalidFile: '请选择不超过10MB的有效资料文件',
      styleSkuLimit: '单款超过500个颜色尺码组合，请核对来源粒度',
      imported: '销售库存资料已导入', importTitle: '导入销售库存', chooseFile: '选择自社分析资料文件',
      importHint: '导入自社分析已发布的资料包。先核对品牌、资料日期、行数及缺项，再确认导入。',
      manualHint: '销售库存来自自社分析；加单量由人工填写。未提供的建议、工厂或日期不会自动推算。',
      empty: '尚未导入已发布的销售库存资料。请管理员核对后导入。',
      apply: '确认导入此版本', businessEnd: '资料截至日期', styleCount: '款数', skuCount: '有效尺码记录',
      excludedAxes: '缺颜色尺码而排除', missingStock: '库存待确认', missingFactory: '缺工厂的款数',
      missingDate: '缺批次日期的款数', stock: '可售库存', sales: '累计销量', inbound: '累计入库',
    },
    adjustmentAlreadyHandled: '调整已经处理，不能重复操作',
    adjustmentNotAllowed: '当前状态不可调整，或已有待处理调整',
    adjustmentNotFound: '调整申请不存在',
    adjustmentResponseInvalid: '无效的调整处理方式',
    adjustTypeInvalid: '无效的调整类型',
    dateFormat: '请填写有效日期',
    deliverySkuInvalid: '颜色尺码必须属于本单，发货量不能超过申请量',
    itemsRequired: '请至少填写一条有效明细',
    brandRequired: '请选择品牌',
    acceptPConfirmedOnly: '只有生产确认后的单据可以接单',
    deliveryQtyRequired: '请填写正数发货量',
    deliveryStatusInvalid: '工厂接单后才能发货',
    fabricShortage: '面料库存不足，无法接单',
    factoryRequired: '请指定作业工厂',
    stockQtyInvalid: '库存数量必须为正数',
    stockReasonInvalid: '无效的库存变动事由',
    stockShortage: '成衣库存不足',
    adminOnly: '此操作仅限管理员',
    duplicateSku: '同一颜色尺码不能重复填写',
    factoryAdminOnly: '工厂账号绑定完成前，此操作仅限管理员',
    notFound: '加单不存在',
    styleCodeRequired: '请填写款号',
    brandNotAllowed: '您没有该品牌的操作权限',
    brandNotFound: '品牌不存在',
    cancelPConfirmedOnly: '只有生产确认状态可以取消生产确认',
    deletedImmutable: '已删除的单据不能修改',
    deleteRequestedOnly: '只有待确认的单据可以删除',
    deliveryDateFormat: '请填写有效交期',
    deliveryDateViaAdjustment: '当前状态不可直接修改交期，请通过调整申请处理',
    expectedRoundRequired: '请填写有效的预计批次',
    factoryAlreadyAccepted: '工厂已接单，不能取消生产确认',
    productionConfirmedOnly: '只有计划确认的单据可以生产确认',
    roundAfterProduction: '生产确认后不能修改预计批次',
    splitConfirmedOnly: '只有计划确认的单据可以拆单',
    splitQtyRequired: '请填写正数拆单量',
    statusNotAllowed: '请使用对应业务操作完成此状态变更',
    statusTransitionInvalid: '当前状态不允许此操作',
    vendorNotFound: '加工厂商不存在',
    vendorRequired: '请选择加工厂商',
    vendorRequiredFirst: '请先保存加工厂商',
    workFactoryInvalid: '作业工厂不属于该加工厂商',
    workFactoryNotFound: '作业工厂不存在',
    status: {
      label: '状态',
      REQUESTED: '待确认',
      CONFIRMED: '计划确认',
      AWAITING_APPROVAL: '调整待批复',
      P_CONFIRMED: '生产确认',
      FACTORY_CONFIRMED: '工厂已接单',
      PRODUCTION_COMPLETED: '交期完成',
      CANCELLED: '已取消',
      DELETED: '已删除',
    },
    styleCode: '款号',
    styleName: '款式名称',
    requester: '申请人',
    vendor: '加工厂商',
    factory: '作业工厂',
    round: '批次(当前→预计)',
    totalQty: '订购量',
    totalAmount: '订购额',
    deliveryDate: '入库要求日期',
    createdAt: '创建时间',
    colorCode: '颜色代码',
    colorName: '颜色名称',
    sizeCode: '尺码',
    suggestedQty: '建议数量',
    totalReorderQty: '全周期建议',
    requestedQty: '申请数量',
    unitPrice: '单价',
    orderAmount: '金额',
    board: {
      title: '加单看板',
      desc: '按周建议量发起加单。三色表示该周需求能否被成衣库存或面料产能覆盖。',
      dwNotConfigured: 'DW 未配置，看板暂不可用。请管理员配置 DW_DATABASE_URL 后执行同步。',
      dwNoData: 'DW 已配置但尚未装载快照，等待首次同步后这里会显示建议量。',
      searchPh: '搜款号 / 品名',
      snapshot: '数据快照日 {d}',
      loadColors: '展开颜色明细',
      hqStock: '总部库存',
      weeklySales: '周销量',
      round: '批次',
      season: '季节',
      planner: '企划',
      sellthrough: '售罄率',
      windowQty: 'sp={sp} 窗口量',
      actions: '操作',
      request: '申请加单',
      hide: '隐藏',
    },
    requestDialog: {
      title: '加单申请 · {style}',
      manualStyle: 'DW 中无此款：按手工登记创建，预计批次将为空。',
      sp: '销售周期(周)',
      vendor: '加工厂',
      round: '当前批次',
      weekWindow: '窗口建议量',
      windowHint: '窗口 [W+{start} 起 {sp} 周]；改交期或 sp 后可一键重算预填。',
      recalc: '重算预填',
      manualFlag: '已手改',
      qtyRequired: '请至少为一个尺码填写大于 0 的申请量',
      reasonPh: '加单理由（选填）',
      total: '合计 {n} 件',
      submit: '提交申请',
      created: '加单申请已创建',
    },
    prod: {
      title: '生产确认',
      desc: '计划确认后的单据。指定入库要求日期、预计批次与加工厂后进行生产确认。',
      count: '待生产确认 {n} 单',
      expectedRound: '预计批次',
      workFactory: '作业工厂',
      readiness: '可确认',
      ready: '可确认',
      blocked: '待完善',
      confirm: '生产确认',
      confirmTitle: '生产确认',
      confirmPrompt: '确认后该单进入「生产确认」状态，交期与批次将锁定。确认继续？',
      confirmed: '生产确认完成',
      vendorMissing: '未指定加工厂',
      roundMissing: '未保存预计批次',
      dateSaved: '入库要求日期已更新',
      roundSaved: '预计批次已保存',
      roundInvalid: '批次格式不正确（两位数字，如 02）',
      vendorSaved: '加工厂已更新（工作工厂自动跟随）',
      saveRound: '保存',
    },
    history: {
      title: '加单历史',
      desc: '全部加单申请与全程沟通履历。汇总与列表同口径刷新。',
      includeDeleted: '包含已删除',
      export: '导出 Excel',
      generatedAt: '汇总生成日 {d}',
      cardQty: '共 {n} 件',
      noData: '暂无加单数据',
      itemsTitle: '尺码明细',
      timelineTitle: '沟通履历',
      showTimeline: '展开履历',
      hideTimeline: '收起履历',
    },
    action: {
      REQUEST_CREATED: '创建申请',
      REQUEST_DELETED: '删除申请',
      STATUS_CHANGED: '状态变更',
      DELIVERY_DATE_CHANGED: '变更入库要求日期',
      SUPPLIER_CHANGED: '变更加工厂商',
      FACTORY_CHANGED: '变更作业工厂',
      EXPECTED_ROUND_CHANGED: '变更预计批次',
      PRODUCTION_CONFIRMED: '生产确认',
      PRODUCTION_CANCELLED: '取消生产确认',
      SPLIT_CREATED: '拆单分配工厂',
      FACTORY_CONFIRMED: '工厂接单',
      FACTORY_CONFIRM_ROLLBACK: '工厂接单回滚',
      FABRIC_DEDUCTED: '面料生产扣减',
      ADJUSTMENT_REQUESTED: '工厂提交调整',
      ADJUSTMENT_CANCELLED: '工厂撤回调整',
      ADJUSTMENT_RESPONDED: '总部批复调整',
      DELIVERY_COMPLETED: '发货完成',
      HISTORY_RESTORED: '单据还原',
    },
    error: {
      FABRIC_SHORTAGE: '面料库存不足，无法接单',
      STOCK_SHORTAGE: '成衣库存不足',
      ACCEPT_P_CONFIRMED_ONLY: '只有「生产确认」状态可以接单',
      DELETE_REQUESTED_ONLY: '只有「待确认」状态的加单可以删除',
      DELIVERY_DATE_VIA_ADJUSTMENT: '当前状态不可直接修改入库要求日期，请通过调整申请处理',
      ROUND_AFTER_PRODUCTION: '生产确认后不可修改预计批次，请先取消生产确认',
      DW_NOT_CONFIGURED: 'DW 未配置，看板数据不可用',
      BRAND_NOT_ALLOWED: '您没有该品牌的操作权限',
      FACTORY_ADMIN_ONLY: '工厂操作暂仅限管理员（工厂账号体系落地后开放）',
    },
  },
};
